import { cobraApi } from "../framework";

const state = {
  ready: false,
  participantId: null,
  participantType: null,
  hireDate: null,
  employeeType: null,
  payrollType: null,
  tobaccoUse: null,
  employeeNameIfDependent: null,
  employeeSsnIfDependent: null,
}

const getters = {
  cobraParticipant: (state) => {
    return state;
  },
}

const actions = {
  async loadCobraParticipant(context, data) {
    if (context.state.participantId !== data.participantId) {
      setReady(context, false);
    }

    let id = data.participantId;
    if (!id) return;

    let cobraParticipant = await cobraApi.get(`participant/${data.participantId}/cobra`);

    if (!cobraParticipant) context.commit("resetCobraParticipant");
    else context.commit('setCobraParticipant', cobraParticipant);

    setReady(context, true);
  },
  async saveCobraParticipant(context, data) {
    var updatedData = { ...context.state, ...data };
    context.commit('setCobraParticipant', updatedData);

    await cobraApi.put(`participant/${data.participantId}/cobra`, updatedData);
    context.dispatch("loadCobraParticipant", { participantId: data.participantId });
  },
}

const mutations = {
  setCobraParticipant(state, cobraParticipant) {
    utils.copyCommonProperties(cobraParticipant, state);
  },
  setCobraParticipantReady(state, value) {
    state.ready = value;
  },
  resetCobraParticipant(state) {
    utils.resetStoreStateProperties(state);
  },
}

function setReady(context, value) {
  context.commit("setCobraParticipantReady", value);
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
};



// WEBPACK FOOTER //
// ./src/cobra/x-cobra-participant.js